import React, { useMemo, useRef } from "react";
import { useSelector } from "react-redux";

import Summary from "../../ui-components/summary/summary";
import AccountDetailsCard from "./card/accountDetailsCard";
import AgingItemTitle from "../aging/item/agingItemTitle";
import SummaryAmount from "../../ui-components/summary/summary-format/summaryAmount";
import { ReactComponent as ChartIcon } from "../../images/chart.svg";

import { agingPeriods, IAgingMeta } from "../../app/data/aging/models";
import { agingSelector } from "../../slices/aging/agingSlice";
import useWindowSize from "../../hooks/useWindowsSize";

const AccountDetailsAgingSummary: React.FC<{}> = (props) => {  
  const agingState = useSelector(agingSelector);
  const contentRef = useRef<HTMLDivElement>(null);
  const windowWidth = useWindowSize()[0];

  const { selected, current, ...periods} = agingPeriods;

  const getValue = (field: string) => agingState.data?.[field];

  const getSummary = () => Object.values(periods).map((period: IAgingMeta) => (
    {
      value: (<SummaryAmount value={getValue(period.field)}/>),
      description: (<AgingItemTitle mods={{period: period.period}}>{period.title}</AgingItemTitle>),
    }
  ));

  //eslint-disable-next-line
  const contentWidth = useMemo(() => (contentRef.current && contentRef.current?.scrollWidth), [windowWidth]);

  return (
    <AccountDetailsCard
      title="Aging Summary"
      icon={<ChartIcon />}
      scrollable={true}
      contentWidth={contentWidth}
    >
      <Summary ref={contentRef} mix="account-details__aging-summary" data={getSummary()} isLoading={agingState.loading} />
    </AccountDetailsCard>
  );
};

export default AccountDetailsAgingSummary;